export const TOGGLE_OUTCOME = "big9/TOGGLE_OUTCOME";
export const RESET_OUTCOMES = "big9/RESET_OUTCOMES";
export const TOGGLE_HARRY = "big9/TOGGLE_HARRY";
